.page {
  min-height: 100vh;
}

.stateScreen {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 16px;
  color: var(--text-muted);
  padding: 0 16px;
  text-align: center;
}

.body {
  max-width: var(--content-max);
  margin: 0 auto;
  padding: 16px 16px 48px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sectionLabel {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.promoStack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.monthsStack {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.desktopGrid {
  display: grid;
  grid-template-columns: var(--rail-w) 1fr;
  gap: 40px;
  align-items: start;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}
